module.exports = __webpack_public_path__ + "img/invitation SMMIRP 01.098682c1.jpg";